document.addEventListener( 'DOMContentLoaded', () => {
	const menuLinks = document.querySelectorAll( '.page-header__navigation .wp-block-pages-list__item__link' );
	const menuOpenButton = document.querySelector( '.page-header__navigation .wp-block-navigation__responsive-container-toggle' );
	
	setTabindex();
	
	menuOpenButton.addEventListener( 'click', () => {
		menuOpenButton.classList.toggle( 'is-menu-open' );
		
		if ( menuOpenButton.classList.contains( 'is-menu-open' ) ) {
			menuOpenButton.ariaLabel = bueckmannLocalization.menuClose;
			
			setTabindex( 'show' );
		}
		else {
			menuOpenButton.ariaLabel = bueckmannLocalization.menuOpen;
			
			setTabindex( 'hide' );
		}
	} );
	
	window.addEventListener( 'resize', () => {
		setTabindex();
	} );
	
	function setTabindex( force ) {
		let hide = !! menuOpenButton.offsetHeight;
		
		if ( force === 'show' ) {
			hide = false;
		}
		else if ( force === 'hide' ) {
			hide = true;
		}
		
		if ( hide ) {
			for ( const menuLink of menuLinks ) {
				menuLink.tabIndex = -1;
			}
		}
		else {
			for ( const menuLink of menuLinks ) {
				menuLink.removeAttribute( 'tabindex' );
			}
		}
	}
} );
